import cn from 'classnames';
import React from 'react';
import { Form, Layout } from 'connex-cds';
import styled from 'styled-components';
import style from '../../style';

const Styled = styled.div`
  ${style}
`;

const { Column, Row, Container } = Layout;

export const FormSection = ({ className }) => {
  const {
    Components: {
      AddedBy,
      Reason,
      Quantity,
      ConcreteOnTruck,
      Time,
      CancelButton,
      SaveButton,
      DeleteButton,
      ResetButton,
    },
  } = Form.useFormContext();

  return (
    <Styled className={cn('form-section', className)}>
      <Container flex={1}>
        <Row stretchContent>
          <AddedBy
            options={[
              { id: 'driver', label: 'Driver' },
              { id: 'customer', label: 'Customer' },
            ]}
          />
          <Reason />
        </Row>
        <Row stretchContent>
          <Quantity />
          <ConcreteOnTruck />
        </Row>
        <Row stretchContent>
          <Time />
        </Row>
        <Row>
          <Column>
            <Row>
              <DeleteButton />
              <ResetButton />
            </Row>
          </Column>
          <Column>
            <Row style={{ justifyContent: 'right' }}>
              <CancelButton />
              <SaveButton suppressDisabledStyling />
            </Row>
          </Column>
        </Row>
      </Container>
    </Styled>
  );
};
